var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"text-capitalize",attrs:{"loading":_vm.loading},on:{"click":function($event){return _vm.handleClean()}}},[_vm._v("Remove Zero Balance Memebers")])
}
var staticRenderFns = []

export { render, staticRenderFns }